import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class PenalidadesNotificacoesApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscarNotificacoesPenalidade({ idPenalidade, tipoEntidade, paginacao }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.notificacoes.getUrlBuscarNotificacoesPenalidade(idPenalidade),
			filters: { tipo: tipoEntidade },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async inserirNotificacaoPenalidade(objt) {
		return await axios.post(this.urlBuilder.notificacoes.getUrlInserirNotificacaoPenalidade(), objt)
	}
}

export default PenalidadesNotificacoesApiClient
